import React from "react";
import { HeaderBarProps } from "web/react/components/__LEGACY__/app-header/header-bar/header-bar";
import NotificationsLink from "./notifications-link";
// eslint-disable-next-line css-modules/no-unused-class
import SavedSearchLink from "./saved-search-link";
import WishListLink from "./wish-list-link";

export type AccountLink = {
    url: string;
};

type AccountLinks = Pick<
    HeaderBarProps,
    | "my_searches_url"
    | "has_items_in_wishlist"
    | "saved_item_url"
    | "notifications_url"
    | "notifications_count"
>;

function AccountLinks({
    my_searches_url: mySearchesUrl,
    saved_item_url: savedItemUrl,
    has_items_in_wishlist: hasItemsInWishlist,
    notifications_url: notificationsUrl,
    notifications_count: notificationsCount,
}: AccountLinks): JSX.Element {
    return (
        <>
            <SavedSearchLink url={mySearchesUrl as string} />
            <WishListLink url={savedItemUrl as string} hasItemsInWishlist={hasItemsInWishlist} />
            <NotificationsLink
                url={notificationsUrl as string}
                notificationsCount={notificationsCount}
            />
        </>
    );
}

export default AccountLinks;
